import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import i18n from 'i18n';
import { pxToRem } from 'utils/ui/units';
import { getColorBlock } from 'utils/ui/colors';
import Box from 'components/Box';
import useChartist from 'hooks/useChartist';
import ChartTooltips from '../ChartTooltips';
import Icon from 'components/Icon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ChartWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['chartColor', 'height', 'isEmpty'].includes(prop);
  }
}).withConfig({
  displayName: "SimpleChart__ChartWrapper",
  componentId: "sc-4rgfkm-0"
})(["position:relative;.ct-label{font-size:0.7rem;color:currentColor;opacity:0.6;}.ct-axis-title{font-size:0.75rem;font-weight:600;fill:currentColor;}> svg{", " vertical-align:middle;color:", ";}.ct-line{fill:none;stroke:currentColor;stroke-width:4px;}.ct-area{fill:currentColor;opacity:0.1;}.ct-grid{stroke:black;opacity:0.1;}", ""], function (p) {
  return p.height && css(["height:", ";"], pxToRem(p.height));
}, function (p) {
  return getColorBlock(p.chartColor, p.theme);
}, function (p) {
  return p.isEmpty && "\n\t\t.ct-line {\n\t\t\topacity: 0.2;\n\t\t\tstroke-dasharray: 10;\n\t\t}\n\t\t.ct-area {\n\t\t\topacity: 0;\n\t\t}\n\t";
});
var defaultOptions = {
  showArea: true,
  showPoint: false,
  lineSmooth: false,
  fullWidth: true,
  chartPadding: {
    top: 4,
    bottom: 4,
    left: 0,
    right: 0
  },
  axisX: {
    offset: 0,
    showLabel: false,
    showGrid: false
  },
  axisY: {
    offset: 0,
    showLabel: false,
    showGrid: false,
    low: 0
  }
};

// Points for chartist series to render when no data is available
function getRandomPoints() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  return Array(length).fill(1).map(function () {
    return Math.random();
  });
}
function SimpleChart(_ref) {
  var labels = _ref.labels,
    data = _ref.data,
    height = _ref.height,
    name = _ref.name,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'links' : _ref$color,
    tooltipProps = _ref.tooltipProps,
    _ref$tooltipDistance = _ref.tooltipDistance,
    tooltipDistance = _ref$tooltipDistance === void 0 ? 8 : _ref$tooltipDistance,
    zeroValueTooltipMinDistance = _ref.zeroValueTooltipMinDistance,
    getTooltipReadout = _ref.getTooltipReadout,
    isEmpty = _ref.isEmpty,
    _ref$emptyContent = _ref.emptyContent,
    emptyContent = _ref$emptyContent === void 0 ? i18n.t('empty_no_data') : _ref$emptyContent,
    _ref$showAxisX = _ref.showAxisX,
    showAxisX = _ref$showAxisX === void 0 ? false : _ref$showAxisX,
    legend = _ref.legend,
    labelInterpolationFnc = _ref.labelInterpolationFnc;
  var hostRef = useRef(null);
  var axisBottomOffset = 20;
  var axisOverlayCompensationX = 0;
  var axisChartPadding = {
    left: 0,
    right: 0
  };
  var options = _objectSpread(_objectSpread({}, defaultOptions), {}, {
    height: showAxisX ? height ? height - axisBottomOffset : height : height
  }, showAxisX && {
    chartPadding: _objectSpread(_objectSpread({}, defaultOptions.chartPadding), {}, {
      bottom: axisBottomOffset
    }, axisChartPadding),
    axisX: {
      offset: axisBottomOffset,
      showLabel: true,
      showGrid: false,
      labelInterpolationFnc: labelInterpolationFnc !== null && labelInterpolationFnc !== void 0 ? labelInterpolationFnc : function (value, index) {
        if (!labels || labels.length <= 12) return value;
        var interval = Math.ceil(labels.length / 8);
        return index % interval === 0 ? value : null;
      }
    }
  });
  var hasData = !isEmpty && data && data.length !== 0;
  useChartist(hostRef, {
    type: 'Line',
    data: {
      labels: labels,
      series: [hasData ? data : getRandomPoints()]
    },
    options: options,
    preserveAspectRatio: 'none'
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ChartWrapper, {
      ref: hostRef,
      chartColor: color,
      height: height,
      isEmpty: !hasData,
      children: hasData ? /*#__PURE__*/_jsx("div", {
        style: showAxisX ? {
          position: 'absolute',
          top: 0,
          left: axisChartPadding.left,
          right: axisChartPadding.right,
          bottom: axisBottomOffset,
          transform: "translateX(".concat(axisOverlayCompensationX, "px)")
        } : undefined,
        children: /*#__PURE__*/_jsx(ChartTooltips, {
          data: data,
          labels: labels,
          name: name,
          tooltipProps: tooltipProps,
          tooltipDistance: tooltipDistance,
          zeroValueTooltipMinDistance: zeroValueTooltipMinDistance,
          getTooltipReadout: getTooltipReadout
        })
      }) : /*#__PURE__*/_jsx(Box, {
        dimmed: true,
        bottom: true,
        right: true,
        position: "absolute",
        mx: "xs",
        my: "xxs",
        children: emptyContent
      })
    }), legend && /*#__PURE__*/_jsxs(Box, {
      dimmed: true,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      mt: "xxs",
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "dot",
        color: "links",
        scale: 1
      }), /*#__PURE__*/_jsx(Box, {
        as: "span",
        style: {
          fontSize: '0.75rem'
        },
        children: legend
      })]
    })]
  });
}
export default SimpleChart;